//Created by wangshuyi on 2021/7/20.

'use strict';
export default {
  name: 'dol-form-model',
  functional: true,
  props: [],
  render(h, { props, data, children }) {
    if(data.attrs){
      data.attrs.layout = data.attrs.layout || 'horizontal';
      data.attrs.labelCol = data.attrs.labelCol || {span: 4};
      data.attrs.wrapperCol = data.attrs.wrapperCol || {span: 20};
    }else if(data.props){
      data.props.layout = data.props.layout || 'horizontal';
      data.props.labelCol = data.props.labelCol || {span: 4};
      data.props.wrapperCol = data.props.wrapperCol || {span: 20};
      // data.props.shape = data.props.shape || 'circle';
      // data.props.size = data.props.size || 'small';
    }else{
      data.props = {
        layout: 'horizontal',
        labelCol: {span: 4},
        wrapperCol: {span: 20},
      }
    }

    return h('a-form-model', data, children);
  }
}
